import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LanguageSwitcher } from '../language-switcher.model';
import { NavigationEnd, Router } from '@angular/router';
import { UiLocaleService } from '../../../services/ui-locale.service';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';

const CURRENT_NAVIGATION_INDEX = 1;
const SEQUENCE_SEPARATOR = ',';
const HIDDEN_LOCALE = 'bs';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.css'],
  providers: [LanguageSwitcher]
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  @Input() authView = false;
  private routeChanges: Subscription;
  public showSwitcher = false;
  public showSwitcherRoutes = [
    '/operating-standards',
    '/admin/all-standards',
    'dashboard/standards',
    '/admin/all-standards-head'
  ];

  private secretSequence: string[] = [];
  private requiredSequence: string[] = [
    'en', 'en', 'en',
    'ru', 'ru', 'ru', 
    'ch', 'ch', 'ch', 
    'en', 'ru', 'ch'  
  ];

  constructor(public languageSwitcher: LanguageSwitcher,
              private uiLocaleService: UiLocaleService,
              private router: Router) {

    this.routeChanges = this.router.events.filter(event => event instanceof NavigationEnd)
      .pairwise().subscribe((value: [NavigationEnd, NavigationEnd]) => {

      for (const routePath of this.showSwitcherRoutes) {
        if (value[CURRENT_NAVIGATION_INDEX].url.endsWith(routePath)) {
          this.showSwitcher = true;
          break;
        } else {
          this.showSwitcher = false;
        }
      }

    });
  }

  ngOnInit() {
    if (this.authView) {
      this.uiLocaleService.initialize();
    } else {
      this.languageSwitcher.getLanguage();
    }
  }

  ngOnDestroy(): void {
    this.routeChanges.unsubscribe();
  }

  switchLang(lang) {
    this.secretSequence.push(lang);

    if (this.secretSequence.length > this.requiredSequence.length) {
      this.secretSequence.shift();
    }

    if (this.secretSequence.length === this.requiredSequence.length &&
        this.secretSequence.join(SEQUENCE_SEPARATOR) === this.requiredSequence.join(SEQUENCE_SEPARATOR)) {
      this.secretSequence = [];
      lang = HIDDEN_LOCALE;
    }

    if (this.authView) {
      this.uiLocaleService.setLocale(lang, false);
    } else {
      this.uiLocaleService.setLocale(lang);
    }
  }

  getCurrentLang() {
    return this.uiLocaleService.getCurrentLocale();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/language-switcher/language-switcher/language-switcher.component.ts